import useChineseTemplesData from "./useChineseTemplesData.js"
import useChurchesData from "./useChurchesData.js"
import useIslamicMosquesData from "./useIslamicMosquesData.js"
import useOtherTemplesData from "./useOtherTemplesData.js"
import useSikhTemplesData from "./useSikhTemplesData.js"
import useHinduTemplesData from "./useHinduTemplesData.js"
import usePublicationsData from "./usePublicationsData.js"

const type = {
  CHINESE: 'c',
  CHURCH: 'C',
  ISLAMIC: 'I',
  OTHERS: 'o',
  SIKH: 's',
  HINDU: 'h',
}

/**
 * 
 * @returns {Array}
 */
const useMapData = () => {
  let chineseTemples = useChineseTemplesData()
  let churches = useChurchesData()
  let islamicMosques = useIslamicMosquesData()
  let otherTemples = useOtherTemplesData()
  let sikhTemples = useSikhTemplesData()
  let hinduTemples = useHinduTemplesData()
  let pubsData = usePublicationsData();

  let data = [
    ...chineseTemples.map(e => ({ ...e, type: type.CHINESE })),
    ...churches.map(e => ({ ...e, type: type.CHURCH })),
    ...islamicMosques.map(e => ({ ...e, type: type.ISLAMIC })),
    ...otherTemples.map(e => ({ ...e, type: type.OTHERS })),
    ...sikhTemples.map(e => ({ ...e, type: type.SIKH })),
    ...hinduTemples.map(e => ({ ...e, type: type.HINDU })),
  ]

  // Parse non-string fields
  data = data.map(e => ({
    ...e,
    website: e.website?.split("\n") ?? [],
    telephone_number: e.telephone_number?.split("\n") ?? [],
    established_year: parseInt(e.established_year),
    longitude: parseFloat(e.longitude),
    latitude: parseFloat(e.latitude),
    pubs: pubsData.filter(pub => pub.place_id === e.id)
  }))

  return data
}

export default useMapData
